import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message, translator } from 'mage-i18n';
import { VerticalRhythm, withResponsive } from 'mage-components';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';
import {
  ButtonPrimary,
  IllustrationSmooth,
  Typography,
  SpacerVertical,
  ScrollView,
} from '@klarna/bubble-ui';
import { analytics } from 'moet-core';

import { ContainerTemplate, MessagingStep } from '@/components';
import { getSelectedPlatform } from '@/selectors/platforms';

import { ANALYTICS_EVENTS } from './analyticsEvents';
import { CY_MERCHANT_NATIVE_PLATFORM_CONTAINER_IDS } from './constants';

const tPrefix = 'products-fe.containers.otherPlatform';

const strong = value => <strong>{value}</strong>;
strong.displayName = 'strong';

export const NativePlatform = ({ t, platform, isMobile }) => (
  <ContainerTemplate>
    <MessagingStep illustration={<IllustrationSmooth />} title={[t(`${tPrefix}.title`)]}>
      <SpacerVertical small />
      <Typography textToken="text-style/text/super-paragraphs/tall/regular">
        <Message path={`${tPrefix}.info2`} params={{ strong, platform: platform.name }} />
      </Typography>
      <VerticalRhythm spacing={5} />
      <ScrollView style={{ alignItems: isMobile ? 'stretch' : 'flex-start' }}>
        <ButtonPrimary
          size="medium"
          onClick={() => {
            analytics.logEvent(ANALYTICS_EVENTS.goToIntegrationGuide, {
              platform: platform.name,
            });
            document.location.href = platform.url;
          }}
          {...generateCyElemId(CY_MERCHANT_NATIVE_PLATFORM_CONTAINER_IDS.BTN_CONTINUE, window)}
        >
          <Message path={`${tPrefix}.link2`} params={{ platform: platform.name }} />
        </ButtonPrimary>
      </ScrollView>
    </MessagingStep>
  </ContainerTemplate>
);
NativePlatform.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  platform: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(state => ({ t: translator(state), platform: getSelectedPlatform(state) }))(
  withResponsive(NativePlatform),
);
